export default ({ request }) => ({
  ecomAmzExpenseListApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzExpenseSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzExpenseDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzExpenseDocListApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/doc/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzExpenseItemListApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/item/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzExpenseDelApi(data = {}) {
    return request({
      url: '/ecom/amz/expense/del',
      method: 'POST',
      data,
    })
  },
  oaEcomAmzExpenseApplyApi(data = {}) {
    return request({
      url: '/oa/ecom/amz/expense/apply',
      method: 'POST',
      data,
    })
  },
  opaEcomAmzExpenseApi(code) {
    return request({
      url: '/ecom/opa/amz/expense/getByCode',
      method: 'GET',
      params: { code },
    })
  },
  //查询银行账户信息接口
  masterCustomerBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/bank/list',
      method: 'post',
      data,
    })
  },
  masterScmInfoBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/bank/list',
      method: 'post',
      data,
    })
  },
  sysUserDetailApi(data = {}) {
    return request({
      url: '/sys/user/detail',
      method: 'post',
      data,
    })
  },
})
